import { Component, OnInit, inject, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { FieldsetModule } from "primeng/fieldset";
import { MessageModule } from "primeng/message";
import { PlatformService } from "../../../platform-service";
import { LessonsToolsMappingService } from "../../services/lessons-tools-mapping.service";
import { GetContentItemsResponseDto } from "../../dtos/get-content-items.response.dto";
import { TargetLinkURICustomizationService } from "../../services/target-link-uri-customization.service";
import { LaunchToolDto } from "../../../launch-tool/dtos/launch-tool.dto";
import { SessionService } from "../../../launch-tool/services/session.service";
import { GetActiveSessionResponseDto } from "../../../launch-tool/dtos/get-active-session.response.dto";

@Component({
  selector: 'app-show-linked-sub-courses',
  standalone: true,
  imports: [
    CommonModule,
    FieldsetModule,
    MessageModule
  ],
  providers: [LessonsToolsMappingService,TargetLinkURICustomizationService,SessionService],
  templateUrl: './show-linked-sub-courses.html',
  styleUrls: ['./show-linked-sub-courses.css']
})
export class ShowLinkedSubCoursesComponent implements OnInit  {
    private route = inject(ActivatedRoute);
    private platformService = inject(PlatformService)
    private lessonsToolsMappingService = inject(LessonsToolsMappingService);
    private targetLinkURICustomizationService = inject(TargetLinkURICustomizationService)
    private sessionService = inject(SessionService);
    contentItems = signal<GetContentItemsResponseDto[]>([])
    courseCode:string =""
    sessionId:string =""
    ngOnInit(): void {
      this.courseCode = this.route.snapshot.params['courseCode'];
      this.sessionId = this.route.snapshot.params['sessionId'];
      this.lessonsToolsMappingService.getContentItemsForLesson(this.courseCode).then((data)=>{
        this.contentItems.set(data);
      })
    }

    async onLinkClick(contentItem: GetContentItemsResponseDto) {
      const targetLinkURI = await this.targetLinkURICustomizationService.getTargetLinkURIAsPerToolMappedTo(this.courseCode,contentItem);
      const userInActiveSession = await this.getUserData();
      const userInfo: LaunchToolDto = {
          "id": userInActiveSession.id,
          "userId": userInActiveSession.learner.id,
          courseCode: this.courseCode,
          "firstName": userInActiveSession.learner.firstName,
          "lastName": userInActiveSession.learner.lastName,
          "email": userInActiveSession.learner.email,
          "createdAt": new Date(),
          "refreshedAt": new Date(),
          "custom":contentItem.custom,
          targetLinkURI
      };
      const openInNewWindow = true;
      this.platformService.initiateCourseLaunch(this.courseCode, userInfo, openInNewWindow)
    }
    private async getUserData():Promise<GetActiveSessionResponseDto>{
            return await this.sessionService.getActiveSession(this.sessionId)
      }
}
